import { parseAssistantPrompt } from './prompt-parser'
import type { VoiceoverVideoPlan } from './planner-schema'

function buildFallbackTopic(prompt: string): string {
  const normalized = prompt.replace(/\s+/g, ' ').trim()
  const cleaned = normalized
    .replace(/^(请|帮我|麻烦你|基于当前项目素材|结合当前项目素材|围绕当前项目素材|针对当前项目素材)[，,\s]*/i, '')
    .replace(/^(做一个|做一条|生成一个|生成一条|出一个|出一条)[，,\s]*/i, '')
    .replace(/^\d+\s*(秒|s|sec|seconds?)的?/i, '')
    .replace(/^(中文|竖版|横版|口播|短视频|视频)?[，,\s]*/i, '')
    .replace(/(口播)?短视频方案/g, '短视频')
    .replace(/剪辑方案/g, '剪辑')
    .replace(/视频方案/g, '视频')
    .replace(/(方案|脚本|规划|剪辑方案|视频方案)[。．.!\s]*$/i, '')
    .trim()

  const collapsed = cleaned || normalized
  return collapsed.slice(0, 24) || '生成口播视频草稿'
}

function buildFallbackScript(topic: string, durationSeconds: number, tone: VoiceoverVideoPlan['tone']): string {
  const opening =
    tone === 'professional'
      ? `大家好，下面用简明的方式为你介绍${topic}。`
      : tone === 'friendly'
        ? `大家好，今天想用更轻松的方式带你快速了解${topic}。`
        : `大家好，今天带你快速认识${topic}。`

  const body = [
    '这支视频会先交代核心主题，再突出最值得关注的亮点和使用场景。',
    '如果你第一次接触这个主题，也能在较短时间里抓住重点，知道它适合解决什么问题。',
    '最后我们会给出一个自然的收束，方便直接作为口播视频草稿继续细化。',
  ]

  const targetSentenceCount = durationSeconds >= 60 ? 4 : 3
  return [opening, ...body.slice(0, targetSentenceCount)].join('')
}

export function buildFallbackVoiceoverVideoPlan(userPrompt: string): VoiceoverVideoPlan {
  const trimmedPrompt = userPrompt.trim()
  const hints = parseAssistantPrompt(trimmedPrompt)
  const topic = buildFallbackTopic(trimmedPrompt)

  return {
    taskType: 'voiceover_video',
    topic,
    script: buildFallbackScript(topic, hints.durationSeconds, hints.tone),
    durationSeconds: hints.durationSeconds,
    aspectRatio: hints.aspectRatio,
    tone: hints.tone,
    needsTts: true,
    needsCaptions: true,
    needsBgm: hints.needsBgm,
    exportDraft: hints.exportDraft,
  }
}
